export const getInitialValues = (practice) => ({
  email: practice?.email ?? '',
  phone: practice?.phone ?? '',
  twilio_phone: practice?.twilio_phone ?? '',
  fax: practice?.fax ?? ''
});
